import { useEffect, useSyncExternalStore } from 'react';
let snapshot = null;
const listeners = new Set();
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const getSnapshot = () => snapshot;
export const useDynamicsContext = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
export function useDynamicsPage(context) {
  const serialized = JSON.stringify(context);
  useEffect(() => {
    const value = JSON.parse(serialized);
    snapshot = value;
    listeners.forEach(listener => listener());
    return () => {
      if (snapshot === value) { snapshot = null; listeners.forEach(listener => listener()); }
    };
  }, [serialized]);
}
export const openDynamics = () => window.dispatchEvent(new Event('dynamics:open'));
